import { TextInput } from "../../components/text-input";
import { DelayedCall } from "../../core/delayed-call";
import { OnEventDispatcher } from "../../core/on-event-dispatcher";
import { StringHelpers } from "../../core/stringhelpers";
import { UserLocation } from '../../core/userlocation';
import { Application } from "../../main";

export class Search extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;
    textInput: TextInput;
    myLocationButton: JQuery<HTMLElement>;
    autoCompleteContainer: JQuery<HTMLElement>;
    value:string = "";
    autoCompleteContainerInner: JQuery<HTMLElement>;


    constructor(container:JQuery<HTMLElement>, searchLabel:string = "Enter search") {
        super();

        this.elm = $("<div class='search'></div>").appendTo(container);

        
        
        this.textInput = new TextInput(this.elm, searchLabel, {
            autocapitalize: false,
            autocomplete: false,
            autocorrect: false,
            multiline: false,
            allowEmpty: true,
            bottomBorder: false
        });
        this.textInput.on("focus", () => {
            this.autoCompleteContainer.addClass("focused");
            container.addClass("focused");
            this.dispatch("focus");
        });
        this.textInput.on("defocus", () => {
            this.autoCompleteContainer.removeClass("focused");
            this.dispatch("defocus");
            container.addClass("focused");
        });
        this.textInput.on("change", () => {
            this.value = this.textInput.value;
            this.dispatch("change");
        });
        this.textInput.on("submit", () => {
            this.value = this.textInput.value;
            this.dispatch("submit");
        });

        let locationIcon:string = `<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" width="26.78" height="26.78" viewBox="0 0 26.78 26.78"><g id="Layer_1-2"><path d="M26.78,11.77h-3.16c-.7-4.42-4.18-7.9-8.6-8.6V0h-3.25v3.16C7.34,3.86,3.86,7.34,3.16,11.77H0v3.25h3.16c.7,4.42,4.18,7.9,8.6,8.6v3.16h3.25v-3.16c4.42-.7,7.9-4.18,8.6-8.6h3.16v-3.25ZM18.42,18.42c-1.29,1.29-3.06,2.08-5.03,2.08-1.97,0-3.74-.79-5.03-2.08-1.29-1.29-2.08-3.06-2.08-5.03,0-1.97.79-3.74,2.08-5.03,1.29-1.29,3.06-2.08,5.03-2.08,1.97,0,3.74.79,5.03,2.08,1.29,1.29,2.08,3.06,2.08,5.03,0,1.97-.79,3.74-2.08,5.03Z" style="fill:#1e4179; stroke-width:0px;"/></g></svg>`;
        this.myLocationButton = $(`<div class='my-location-btn'><div class='icon'>${locationIcon}</div></div>`).appendTo(this.elm);

        this.autoCompleteContainer = $(`<div class='autocomplete-container cleared'></div>`).appendTo(this.elm);
        this.autoCompleteContainerInner = $(`<div class='autocomplete-container-inner'></div>`).appendTo(this.autoCompleteContainer);

        let disableLocate = false;
        let locateDelay = new DelayedCall(() => { disableLocate = false; }, 2000, true);
        this.myLocationButton.on("click", async () => {
            if(disableLocate) return;
            disableLocate = true;
            locateDelay.restart();
            Application.events.dispatch("locate_user_requested");
        });
        Application.events.on("locate_user_start", async () => {
            this.myLocationButton.addClass("animate");
        });
        Application.events.on("locate_user_complete", async () => {
            this.myLocationButton.removeClass("animate");
        });
    }

    clear():void {
        this.autoCompleteContainerInner.html("");
        this.autoCompleteContainer.addClass("cleared");
    }

    highlight(subject:string, searchFragments:Array<string>) {
        if(subject==null||searchFragments==null) return;
        let r = subject;
        for(let m in searchFragments) {
            let search = searchFragments[m];
            if(search.length<=2) continue;
            const re = new RegExp(search, 'gi'); // global, insensitive
            r = r.replace(re, `<mark>$&</mark>`);
        }
        return r;
    }

    add(header:string, line1:string, line2:string, search:string):JQuery<HTMLElement> {
        this.autoCompleteContainer.removeClass("cleared");
        let searchFragments = StringHelpers.getStringFragments(search);
        header = this.highlight(header, searchFragments);
        line1 = this.highlight(line1, searchFragments);
        line2 = this.highlight(line2, searchFragments);
        return $(`
            <div class='autocomplete-item'>
                <div class='autocomplete-icon'></div>
                <div class='autocomplete-info'>
                    <h3>${header}</h3>
                    <p>${line1}</p>
                    <p><i>${line2}</i></p>
                </div>
            </div>
        `).appendTo(this.autoCompleteContainerInner);
    }



}